import posthog from 'posthog-js'

// https://martijnhols.nl/blog/everything-about-google-translate-crashing-react
function patchDomForBrowserTranslate(): void {
  if (typeof Node !== 'function' || Node.prototype == null) return

  const patchReported = { removeChild: false, insertBefore: false }

  const reportOnce = (method: keyof typeof patchReported) => {
    if (patchReported[method]) return
    patchReported[method] = true
    posthog.register({ browser_translate_dom_patch: method })
    posthog.capture('browser_translate_dom_patch', { method })
  }

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(
    this: Node,
    child: T
  ): T {
    if (child.parentNode !== this) {
      reportOnce('removeChild')
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode != null && referenceNode.parentNode !== this) {
      reportOnce('insertBefore')
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}

patchDomForBrowserTranslate()
